import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PlanSingleComponent from './PlanSingleComponent'

const propTypes = {
  tables: PropTypes.array.isRequired,
  addSideTable: PropTypes.func.isRequired,
  map: PropTypes.object,
  currentPricing: PropTypes.object.isRequired
}

class PlanComponent extends Component {
  render() {
    const { tables, addSideTable, map } = this.props
    const planContainerStyle = {
      width: map.width + 80,
      height: map.height + 80
    }
    return (
      <div className="planContainer" style={planContainerStyle}>
        {tables.map((table, index) => {
          return (
            <PlanSingleComponent
              key={index}
              table={table}
              addSideTable={addSideTable}
              currentPricing={this.props.currentPricing}
            />
          )
        })}
      </div>
    )
  }
}

PlanComponent.propTypes = propTypes
export default PlanComponent



// WEBPACK FOOTER //
// ./src/routes/Home/components/PlanComponent.js